module.exports = __webpack_public_path__ + "img/slider1.8a278c95.jpg";